import React from "react";
import { useHistory } from "react-router";
import { useTimer } from "react-timer-hook";
import { format } from "date-fns";

const ExamButton = ({ e, i, setSelectedExam }) => {
  const history = useHistory();
  const timeLeft = () =>
    parseInt((hours * 60 * 60 + minutes * 60 + seconds) / 90);
  const padInt = (num) => (num > 9 ? num : `0${num}`);

  const current = new Date();
  const start = new Date(e.startedAt);
  const end = new Date(start.getTime() + 9000000);
  const { seconds, minutes, hours } = useTimer({ expiryTimestamp: end });

  if (e.status !== "failed" && e.status !== "passed" && current > end) {
    return (
      <button
        className="btn btn-lg btn-outline-primary text-ul text-start my-1"
        key={i}
        onClick={() => history.push(`/exam/${e.exam}`)}
      >
        {e.examName}
        <small className="ms-2 text-warning fs-6 bg-white px-2 rounded-pill">
          Timed Out
        </small>
      </button>
    );
  }
  switch (e.status) {
    case "pending":
      if (
        !e.startDate ||
        e.startDate.slice(0, 10) <= new Date().toISOString().slice(0, 10)
      ) {
        return (
          <button
            className="btn btn-lg btn-outline-primary text-start my-1"
            data-bs-toggle="modal"
            data-bs-target="#detailsModal"
            key={i}
            onClick={() => setSelectedExam(e)}
          >
            {e.examName}
            <small className="ms-2 text-muted fs-6 bg-white px-2 rounded-pill">
              Click Here To Start.
            </small>
          </button>
        );
      } else {
        return (
          <button
            className="btn btn-lg btn-outline-secondary disabled text-ul text-start my-1"
            key={i}
          >
            {e.examName}
            <small className="ms-2 text-warning fs-6 bg-white px-2 rounded-pill">
              Please wait till
              <span className="fw-bold">
                {" "}
                {format(new Date(e.startDate), "MMM. dd, yyy")}
              </span>
            </small>
          </button>
        );
      }
    case "started":
      return (
        <button
          className="btn btn-lg btn-outline-primary text-start d-flex align-items-center my-1"
          key={i}
          onClick={() => history.push(`/exam/${e.exam}`)}
        >
          {e.examName}
          <small className="ms-2 text-primary fs-6 bg-white px-2 rounded-pill">
            In Progress
          </small>
          <small className="ms-auto text-muted fs-6 bg-white px-2 rounded-pill">
            Time Left -{" "}
          </small>
          <small
            className={`fw-bold ms-1 ${
              timeLeft() < 10
                ? "text-danger"
                : timeLeft() < 20
                ? "text-warning"
                : "text-dark"
            }`}
          >
            {padInt(hours)}:{padInt(minutes)}:{padInt(seconds)}
          </small>
        </button>
      );
    case "failed":
      return (
        <button
          className="btn btn-lg btn-outline-primary text-start my-1"
          key={i}
          onClick={() => history.push("/certificate")}
        >
          {e.examName}
          <small className="ms-2 text-danger fs-6 bg-white px-2 rounded-pill">
            Failed
          </small>
        </button>
      );
    case "passed":
      return (
        <button
          className="btn btn-lg btn-outline-primary text-start my-1"
          key={i}
          onClick={() => history.push("/certificate")}
        >
          {e.examName}
          <small className="ms-2 text-success fs-6 bg-white px-2 rounded-pill">
            Passed, Click Here To Print Certificate.
          </small>
        </button>
      );
    default:
      return "Invalid Entry";
  }
};

export default ExamButton;
